<template>
  <div class="flex" :class="{ head: isHeader }">
    <div class="left">{{ title }}</div>
    <div class="right">
      <div v-if="gravatar" class="gravatar" :style="$bgd(gravatar)" />
      <span>{{ data }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "flex",
  props: ["title", "data", "gravatar", "isHeader"],
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  .left {
    opacity: 0.6;
  }
  .right {
    font-weight: 400;
    display: flex;
    align-items: center;
  }
}
.gravatar {
  $size: 15px;
  width: $size;
  height: $size;
  border-radius: 50%;
  margin: 0 3px 0 0;
}
.head {
  padding: 0 0 5px 0;
  font-size: 1rem;
  .left {
    opacity: 1;
    font-weight: 500;
  }
  .right {
    @include avenir-demi();
    color: $red;
  }
}
</style>
